"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearAll = clearAll;
exports.clearNonPersistent = clearNonPersistent;
exports.getBuilder = getBuilder;
var _storagebuilder = _interopRequireDefault(require("./storagebuilder"));
var _scopedstorage = _interopRequireDefault(require("./scopedstorage"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Get the storage builder for an app
 * @param appId App ID to scope storage
 */
function getBuilder(appId) {
  return new _storagebuilder.default(appId);
}

/**
 * Clear values from storage
 * @param storage The storage to clear
 * @param pred Callback to check if value should be cleared
 */
function clearStorage(storage, pred) {
  Object.keys(storage).filter(k => pred ? pred(k) : true).map(storage.removeItem.bind(storage));
}

/**
 * Clear all values from all storages
 */
function clearAll() {
  const storages = [window.sessionStorage, window.localStorage];
  storages.map(s => clearStorage(s));
}

/**
 * Clear ony non persistent values
 */
function clearNonPersistent() {
  const storages = [window.sessionStorage, window.localStorage];
  storages.map(s => clearStorage(s, k => !k.startsWith(_scopedstorage.default.GLOBAL_SCOPE_PERSISTENT)));
}
//# sourceMappingURL=index.js.map